// FollowUpModal.jsx
import { Dialog } from "@headlessui/react";
import FollowUpsTab from "../FollowUps";

export default function FollowUpModal({ isOpen, onClose, currentUserId }) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />

      {/* Contenu centré */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="relative bg-white p-6 rounded-xl w-full max-w-[70%] max-h-[90vh] overflow-y-auto shadow-xl">
          {/* Bouton X dans le coin */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
            aria-label="Fermer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <Dialog.Title className="text-xl font-bold mb-4 mt-8"></Dialog.Title>
          <FollowUpsTab
            currentUserId={currentUserId}
            showUserSelection={true}
          />
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
